import { SxProps, Theme } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';

export const screenContainer: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  padding: GLOBAL_MARGIN_HORIZONTAL,
};

export const formCard: SxProps<Theme> = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 3,
  border: theme => `1px solid ${theme.palette.divider}`,
  mb: 2,
};

export const listCard: SxProps<Theme> = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 3,
  border: theme => `1px solid ${theme.palette.divider}`,
};

export const contentBox: SxProps<Theme> = {
  width: '100%',
  marginTop: GLOBAL_MARGIN_HORIZONTAL * 2,
};
